import React from "react";
import ProductGrid from "./components/ProductGrid";

function Dryness() {
  return <ProductGrid params={{ skinConcern: "dryness" }} />;
}

export default Dryness;
